<template>
  <div>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <h3>ตารางรายละเอียดจุดการติดตั้ง</h3>
      </b-col>
      <b-col
        v-for="(item, index) in menu"
        :key="index"
        lg="12"
        md="12"
      >
        <b-card
          no-body
          class="mb-1"
        >
          <b-button
            v-b-toggle="'collapse' + index"
            block
            variant="primary"
          >
            <div class="d-flex justify-content-between flex-wrap pt-1">
              <div>
                <h4 v-if="menu[index].DeptGroupName == 'บทช.กัลปพฤกษ์'">
                  ทช.ส่วนกลาง
                </h4>
                <h4 v-if="menu[index].DeptGroupName != 'บทช.กัลปพฤกษ์'">
                  {{ menu[index].DeptGroupName }}
                </h4>
              </div>
              <div>
                <feather-icon
                  :icon="visible[index] ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                  size="18"
                />
              </div>
            </div>
          </b-button>
          <b-collapse
            :id="'collapse' + index"
            v-model="visible[index]"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-table
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="menu[index].DeptList"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
              <template #cell(SEM_Total)="data">
                {{ data.item.SEM_Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} ตู้
              </template>
              <template #cell(SEM_Online)="data">
                {{ data.item.SEM_Online.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
              </template>
              <template #cell(SEM_Offline)="data">
                {{ data.item.SEM_Offline.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
              </template>
              <template #cell(Detail)="data">
                <div>
                  <b-link
                    style="text-decoration: underline; color: #11DF00;"
                    :to="{ path: `/4g-sub?DeptID=${data.item.DeptID}`}"
                  >
                    <span>{{ data.Deptname }}ดูเพิ่มเติ่ม</span>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="24"
                    />
                  </b-link>
                </div>
              </template>
            </b-table>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, BTable, BLink,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BLink,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      menu: [],
      visible: [],
      fields: [
        {
          key: 'DeptName',
          label: 'จุดติดตั้ง',
          sortable: true,
        },
        {
          key: 'SEM_Total',
          label: 'จำนวนทั้งหมด',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'SEM_Online',
          label: 'ใช้งานได้',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'SEM_Offline',
          label: 'ใช้งานไม่ได้',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'Detail',
          label: 'รายละเอียด',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fieldsSpeaker
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.get4GTable()
    this.interval = setInterval(() => {
      this.get4GTable()
    }, 300000)
  },
  methods: {
    get4GTable() {
      axios
        .post('/getMenu4GTotal')
        .then(response => {
          this.menu1 = response.data[0].json
          this.menu = JSON.parse(this.menu1)
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
